import { render, staticRenderFns } from "./ChatContent.vue?vue&type=template&id=1426ad07&"
import script from "./ChatContent.vue?vue&type=script&lang=js&"
export * from "./ChatContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports